module.exports = __webpack_public_path__ + "assets/mastercard.b34381c4fe6b2ae81f7f6812d8d838a9.svg";